import { useEffect, useRef, useState } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url"

import { Spinner } from "./spinner"

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc

interface ReportPdfPreviewProps {
  pdfUrl: string
  /** Fired once the first page has finished rendering (clears the "downloading" UI). */
  onReady?: () => void
}

/**
 * Renders ONLY the first page of the report PDF — the "teaser" slice — mirroring
 * the origene ReportsV2 approach. The full document is reachable via Download.
 */
export function ReportPdfPreview({ pdfUrl, onReady }: ReportPdfPreviewProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const update = () => setWidth(el.clientWidth)
    update()
    const ro = new ResizeObserver(update)
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  return (
    <div className="bg-dark-deep px-1 pb-4">
      <div ref={containerRef} className="w-full">
        {width > 0 &&
          (pdfUrl ? (
            <Document file={pdfUrl} loading={<PdfPlaceholder />} error={<PdfPlaceholder />}>
              <Page
                pageNumber={1}
                width={width}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                onRenderSuccess={onReady}
                loading={<PdfPlaceholder />}
              />
            </Document>
          ) : (
            <PdfPlaceholder />
          ))}
      </div>
    </div>
  )
}

function PdfPlaceholder() {
  return (
    <div className="flex aspect-[1200/2068] w-full items-center justify-center">
      <Spinner className="size-8 border-purple-light/60" />
    </div>
  )
}
